var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h3"},[_vm._v("Content Page")]),_c('div',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.$route.params.slug))]),_c('v-container',[_c('vue-simple-markdown',{attrs:{"source":_vm.pageData.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }